"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var program_edit_form_1 = require("../../components/program/program-edit-form");
var EditProgram = function (_a) {
    var match = _a.match;
    var _b = match.params, orgId = _b.orgId, programId = _b.programId;
    return (React.createElement("div", { id: "new-program", className: "container" },
        React.createElement("div", { className: "u-xs-padMd u-sm-spaceTopLg u-flexExpandSides" },
            React.createElement(program_edit_form_1.default, { programId: +programId, organizationId: +orgId }))));
};
exports.default = EditProgram;
//# sourceMappingURL=edit-program.js.map